<template lang="pug">
v-container
  h1 TRIP DETAILS
    v-progress-circular.ml-4.mb-1(v-if="loading" color="primary" indeterminate size="20")
  template(v-if="trip")
    receipt-upload-dialog(v-model="receiptUploadDialog" :trip="trip")
    v-card
      v-card-title.justify-center TRIP SUMMARY
      v-card-text
        v-row
          v-col.pb-0(cols="4")
            p.mb-1.font-weight-bold TRIP ID
          v-col.pb-0(cols="8")
            p.mb-1.body-2 : {{ trip.tripid}}
        v-row.pa-0
          v-col.pt-0.pb-0(cols="4")
            p.mb-1.font-weight-bold HTO CARD
          v-col.pt-0.pb-0(cols="8")
            p.mb-1.body-2 : 1234
        v-row
          v-col.pt-0.pb-0(cols="4")
            p.mb-1.font-weight-bold AGENT
          v-col.pt-0.pb-0(cols="8")
            p.mb-1.body-2 : ARBA
        v-row
          v-col.pt-0.pb-0(cols="4")
            p.mb-1.font-weight-bold DATE
          v-col.pt-0.pb-0(cols="8")
            p.mb-1.body-2 : {{ trip.depart_date }} - {{ trip.return_date }}
        v-row
          v-col.pt-0.pb-0(cols="4")
            p.mb-1.font-weight-bold TOTAL PAX
          v-col.pt-0.pb-0(cols="8")
            p.mb-1.body-2  : {{ trip.totalPax }} ( {{ trip.totalAdult }} Adult |  {{ trip.totalChild }} Child | {{trip.totatChildnb}} Child w/o Bed | {{trip.totalInfant}} Infant )
        v-row
          v-col.pt-0.pb-0(cols="4")
            p.mb-1.font-weight-bold ROOM
          v-col.pt-0.pb-0(cols="8")
            p.mb-1.body-2 : {{ trip.tripleRoom }} Triple | {{ trip.doubleRoom }} Double | {{ trip.singleRoom }} Single
        v-row
          v-col.pt-0.pb-0(cols="4")
            p.mb-1.font-weight-bold TIP
          v-col.pt-0.pb-0(cols="8")
            p.mb-1.body-2 : {{ tripInfo.tipping || 'Not specified' }}
    div.my-4.mx-0.justify-center
      v-btn(color="primary" block depressed large @click="receiptUploadDialog = true") Record Payment
    v-card.justify-center
      v-card-title.justify-center FLIGHT DETAILS
      v-card-text
        v-row
          v-col.text-center(cols="6")
              div.mb-4
                v-icon mdi-airplane-landing
                span.pl-2.font-weight-bold ARRIVAL
              p.mb-1 {{ trip.depart_code}}
              p.mb-1  {{ trip.depart_date}}  {{ trip.depart_time}}
          v-col.text-center(cols="6")
              div.mb-4
                v-icon mdi-airplane-takeoff
                span.pl-2.font-weight-bold DEPARTURE
              p.mb-1 {{ trip.return_code}}
              p.mb-1  {{ trip.return_date}}  {{ trip.return_time}}
    v-card.justify-center.mt-4
      v-card-title.justify-center WhatsApp LINK
      v-card-text.justify-center
        v-btn.secondary(block depressed :href='trip.wa_link') Join
    v-card.justify-center.mt-4
      v-card-title.justify-center WELCOME SIGNAGE
      v-card-text
        v-btn.secondary(block depressed href='https://drive.google.com/file/d/1hkjV3H9PdabhSBrgmyundusiRu3Aurs9/view?usp=sharing' target="_blank") Download
    v-card.justify-center.mt-4
      v-card-title.justify-center HOTEL & TRANSPORT
      v-card-text
        v-row
          v-col
            v-row
              v-col.pb-0
                v-icon.pb-1(dense) mdi-hotel
                span.font-weight-bold  HOTEL
            v-row.mb-4(v-for="hotel in this.hotelInfo")
              v-col.py-0(cols="12") {{ hotel.hotel_name }}
              v-col.py-0(cols="12") Phone: {{ hotel.hotel_phone || '-' }}
              v-col.py-0(cols="12") Check-in: {{ hotel.date_in }}
              v-col.py-0(cols="12") Check-out: {{ hotel.date_out }}
              v-col.py-0(cols="12") Rooms: {{ hotel.total_room.filter(r => r.number > 0).length === 0 ? '-' : '' }}
                v-row(v-for="room in hotel.total_room.filter(r => r.number > 0)")
                  v-col.py-0(cols="12") - {{ room.room }} x {{ room.number }}
              v-col.py-0(cols="12") Notes: {{ hotel.hotel_notes || '-' }}
            a(href="http://pf.kakao.com/_xmAlwj/31737579" target="_blank") More Info
          v-col(v-if="transportInfo.name")
            v-row
              v-col.pb-0
                v-icon.pb-1(dense) mdi-bus
                span.font-weight-bold  TRANSPORT
            p {{ transportInfo.name }} ({{ transportInfo.seat_num }} seater)
            a(href="http://pf.kakao.com/_xmAlwj/30891642" target="_blank") More Info
    v-card.mt-4
      v-card-title.justify-center NAME LIST
      v-card-text
        v-row
          v-col.text-center
            v-btn.secondary(block depressed :href="`https://ca.arbatravel.com/admin/file-room-csv?tripid=${trip.tripid}&exportcsv=`" target="_blank") Room List
          v-col.text-center
            v-btn.secondary(block depressed :href="`https://ca.arbatravel.com/admin/file-addon-csv?tripid=${trip.tripid}&exportcsv=`" target="_blank") Add-Ons
    v-card.mt-4
      v-card-title.justify-center NOTE
      v-card-text {{ tripInfo.notes || 'Nothing specified' }}
    v-card.mt-4
      v-card-title.justify-center ITINERARY
      v-card-text
        v-timeline(v-if="Object.keys(itinerary).length > 0" align-top dense clipped)
          v-timeline-item(fill-dot large v-for="(day, index) in Object.keys(itinerary)")
            template(v-slot:icon)
              span.white--text {{ day | itineraryDate }}
            v-row
              v-col
                v-row(v-for="a in itinerary[day].activities")
                  v-col.pt-0(cols="12") {{ a.activity_name }}
              v-col
                v-row(v-for="m in itinerary[day].meals")
                  v-col.pt-0(cols="12") {{ m.name }} ({{ m.start_time.substring(0, m.start_time.length - 3) }})
        span(v-else) No itinerary scheduled
</template>

<script>
import parse from 'date-fns/parse'
import format from 'date-fns/format'
import ReceiptUploadDialog from '@/components/ReceiptUploadDialog'

export default {
  name: 'Trip',
  components: { ReceiptUploadDialog },
  filters: {
    itineraryDate (val) {
      const result = parse(val, 'yyyy-MM-dd', new Date())
      return format(result, 'MM/dd')
    }
  },
  data: () => ({
    loading: true,
    trip: null,
    tripInfo: {},
    itineraryInfo: {},
    mealInfo: {},
    hotelInfo: {},
    transportInfo: {},
    receiptUploadDialog: false,
    itinerary: {}
  }),
  computed: {
    tripId () {
      return this.$route.query.trip_id
    }
  },
  mounted () {
    this.fetchTrip()
    this.fetchTripInfo()
    this.fetchItineraryInfo()
  },
  methods: {
    fetchTrip () {
      this.$axios.get(`https://ca.arbatravel.com/api/tripinfo.php?trip_id=${this.tripId}`)
        .then(resp => {
          this.trip = resp.data
          this.loading = false
        })
    },
    fetchTripInfo () {
      this.$axios.get(`https://trip-manager-api.arbatravel.com/trips/?real_trip_id=${this.tripId}`)
        .then(resp => {
          this.tripInfo = resp.data
          this.$axios.get(`https://trip-manager-api.arbatravel.com/transports/?id=${resp.data.transport_id}`)
            .then(resp => {
              this.transportInfo = resp.data
            })
        })
      this.$axios.get(`https://trip-manager-api.arbatravel.com/accommodations/?real_trip_id=${this.tripId}`)
        .then(resp => {
          this.hotelInfo = resp.data.results
        })
    },
    fetchItineraryInfo () {
      const activityReq = this.$axios.get(`https://trip-manager-api.arbatravel.com/itineraries/?real_trip_id=${this.tripId}`)
      const mealReq = this.$axios.get(`https://trip-manager-api.arbatravel.com/meals/?real_trip_id=${this.tripId}`)
      Promise.all([activityReq, mealReq])
        .then(resps => {
          const activities = resps[0].data.results
          const meals = resps[1].data.results
          activities.forEach(i => {
            let day = this.itinerary[i.activity_date]
            if (!day) {
              day = { activities: [], meals: [] }
            }
            day.activities.push(i)
            this.itinerary[i.activity_date] = day
          })

          meals.forEach(i => {
            let day = this.itinerary[i.meal_date]
            if (!day) {
              day = { activities: [], meals: [] }
            }
            day.meals.push(i)
            this.itinerary[i.meal_date] = day
          })

          Object.keys(this.itinerary).forEach(day => {
            this.itinerary[day].activities.sort((a, b) => (a.start_time > b.start_time) ? 1 : -1)
            this.itinerary[day].meals.sort((a, b) => (a.start_time > b.start_time) ? 1 : -1)
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>